import React, { useState, useEffect } from 'react';
import CourseApplicationModal from './CourseApplicationModal';

const CourseApplicationModalWrapper: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [courseData, setCourseData] = useState<{
    id: string;
    title: string;
    date: string;
    price: string;
    instructor: string;
  } | null>(null);

  useEffect(() => {
    const handleModalTrigger = (event: Event) => {
      const target = event.target as HTMLElement;
      if (target.matches('[data-bs-target="#courseApplicationModal"]')) {
        event.preventDefault();
        
        const button = target as HTMLButtonElement;
        setCourseData({
          id: button.dataset.courseId || '',
          title: button.dataset.courseTitle || '',
          date: button.dataset.courseDate || '',
          price: button.dataset.coursePrice || '',
          instructor: button.dataset.courseInstructor || ''
        });
        setIsOpen(true);
      }
    };

    document.addEventListener('click', handleModalTrigger);
    return () => document.removeEventListener('click', handleModalTrigger);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    setCourseData(null);
  };

  return (
    <CourseApplicationModal 
      isOpen={isOpen}
      onClose={handleClose}
      courseData={courseData}
      closeOnOverlayClick={true}
      closeOnEscape={true}
    />
  );
};

export default CourseApplicationModalWrapper;